.transcriptStatusExplainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.explainerText {
  margin-right: 1.8rem;
}
